import { render, staticRenderFns } from "./wine-add.vue?vue&type=template&id=577a7fe8"
import script from "./wine-add.vue?vue&type=script&lang=js"
export * from "./wine-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports